{
    "name": "Anycubic",
    "version": "01.10.00.01",
    "force_update": "0",
    "description": "Anycubic configurations",
    "machine_model_list": [
        {
            "name": "Anycubic i3 Mega S",
            "sub_path": "machine/Anycubic i3 Mega S.json"
        },
        {
            "name": "Anycubic Chiron",
            "sub_path": "machine/Anycubic Chiron.json"
        },
        {
            "name": "Anycubic Vyper",
            "sub_path": "machine/Anycubic Vyper.json"
        },
        {
            "name": "Anycubic Kobra Max",
            "sub_path": "machine/Anycubic Kobra Max.json"
        },
        {
            "name": "Anycubic 4Max Pro",
            "sub_path": "machine/Anycubic 4Max Pro.json"
        },
        {
            "name": "Anycubic 4Max Pro 2",
            "sub_path": "machine/Anycubic 4Max Pro 2.json"
        },
        {
            "name": "Anycubic Kobra 2",
            "sub_path": "machine/Anycubic Kobra 2.json"
        },
        {
            "name": "Anycubic Kobra Plus",
            "sub_path": "machine/Anycubic Kobra Plus.json"
        }
    ],
    "process_list": [
        {
            "name": "fdm_process_common",
            "sub_path": "process/fdm_process_common.json"
        },
        {
            "name": "0.15mm Optimal @Anycubic i3MegaS",
            "sub_path": "process/0.15mm Optimal @Anycubic i3MegaS.json"
        },
        {
            "name": "0.15mm Optimal @Anycubic Chiron",
            "sub_path": "process/0.15mm Optimal @Anycubic Chiron.json"
        },
        {
            "name": "0.15mm Optimal @Anycubic Vyper",
            "sub_path": "process/0.15mm Optimal @Anycubic Vyper.json"
        },
        {
            "name": "0.15mm Optimal @Anycubic KobraMax",
            "sub_path": "process/0.15mm Optimal @Anycubic KobraMax.json"
        },
        {
            "name": "0.15mm Optimal @Anycubic 4MaxPro2",
            "sub_path": "process/0.15mm Optimal @Anycubic 4MaxPro2.json"
        },
        {
            "name": "0.15mm Optimal @Anycubic Kobra2",
            "sub_path": "process/0.15mm Optimal @Anycubic Kobra2.json"
        },
        {
            "name": "0.20mm Standard @Anycubic i3MegaS",
            "sub_path": "process/0.20mm Standard @Anycubic i3MegaS.json"
        },
        {
            "name": "0.20mm Standard @Anycubic Chiron",
            "sub_path": "process/0.20mm Standard @Anycubic Chiron.json"
        },
        {
            "name": "0.20mm Standard @Anycubic Vyper",
            "sub_path": "process/0.20mm Standard @Anycubic Vyper.json"
        },
        {
            "name": "0.20mm Standard @Anycubic KobraMax",
            "sub_path": "process/0.20mm Standard @Anycubic KobraMax.json"
        },
        {
            "name": "0.20mm Standard @Anycubic 4MaxPro",
            "sub_path": "process/0.20mm Standard @Anycubic 4MaxPro.json"
        },
        {
            "name": "0.20mm Standard @Anycubic 4MaxPro2",
            "sub_path": "process/0.20mm Standard @Anycubic 4MaxPro2.json"
        },
        {
            "name": "0.20mm Standard @Anycubic Kobra2",
            "sub_path": "process/0.20mm Standard @Anycubic Kobra2.json"
        },
        {
            "name": "0.20mm Standard @Anycubic KobraPlus",
            "sub_path": "process/0.20mm Standard @Anycubic KobraPlus.json"
        },
        {
            "name": "0.30mm Draft @Anycubic i3MegaS",
            "sub_path": "process/0.30mm Draft @Anycubic i3MegaS.json"
        },
        {
            "name": "0.30mm Draft @Anycubic Chiron",
            "sub_path": "process/0.30mm Draft @Anycubic Chiron.json"
        },
        {
            "name": "0.30mm Draft @Anycubic Vyper",
            "sub_path": "process/0.30mm Draft @Anycubic Vyper.json"
        },
        {
            "name": "0.30mm Draft @Anycubic KobraMax",
            "sub_path": "process/0.30mm Draft @Anycubic KobraMax.json"
        },
        {
            "name": "0.30mm Draft @Anycubic 4MaxPro2",
            "sub_path": "process/0.30mm Draft @Anycubic 4MaxPro2.json"
        },
        {
            "name": "0.30mm Draft @Anycubic Kobra2",
            "sub_path": "process/0.30mm Draft @Anycubic Kobra2.json"
        }
    ],
    "filament_list": [
        {
            "name": "fdm_filament_common",
            "sub_path": "filament/fdm_filament_common.json"
        },
        {
            "name": "fdm_filament_abs",
            "sub_path": "filament/fdm_filament_abs.json"
        },
        {
            "name": "fdm_filament_asa",
            "sub_path": "filament/fdm_filament_asa.json"
        },
        {
            "name": "fdm_filament_pa",
            "sub_path": "filament/fdm_filament_pa.json"
        },
        {
            "name": "fdm_filament_pc",
            "sub_path": "filament/fdm_filament_pc.json"
        },
        {
            "name": "fdm_filament_pet",
            "sub_path": "filament/fdm_filament_pet.json"
        },
        {
            "name": "fdm_filament_pla",
            "sub_path": "filament/fdm_filament_pla.json"
        },
        {
            "name": "fdm_filament_pva",
            "sub_path": "filament/fdm_filament_pva.json"
        },
        {
            "name": "fdm_filament_tpu",
            "sub_path": "filament/fdm_filament_tpu.json"
        },
        {
            "name": "Generic ABS @Anycubic",
            "sub_path": "filament/Generic ABS @Anycubic.json"
        },
        {
            "name": "Generic ASA @Anycubic",
            "sub_path": "filament/Generic ASA @Anycubic.json"
        },
        {
            "name": "Generic PA @Anycubic",
            "sub_path": "filament/Generic PA @Anycubic.json"
        },
        {
            "name": "Generic PA-CF @Anycubic",
            "sub_path": "filament/Generic PA-CF @Anycubic.json"
        },
        {
            "name": "Generic PC @Anycubic",
            "sub_path": "filament/Generic PC @Anycubic.json"
        },
        {
            "name": "Generic PETG @Anycubic",
            "sub_path": "filament/Generic PETG @Anycubic.json"
        },
        {
            "name": "Generic PLA @Anycubic",
            "sub_path": "filament/Generic PLA @Anycubic.json"
        },
        {
            "name": "Generic PLA-CF @Anycubic",
            "sub_path": "filament/Generic PLA-CF @Anycubic.json"
        },
        {
            "name": "Generic PVA @Anycubic",
            "sub_path": "filament/Generic PVA @Anycubic.json"
        },
        {
            "name": "Generic TPU @Anycubic",
            "sub_path": "filament/Generic TPU @Anycubic.json"
        }
    ],
    "machine_list": [
        {
            "name": "fdm_machine_common",
            "sub_path": "machine/fdm_machine_common.json"
        },
        {
            "name": "Anycubic i3 Mega S 0.4 nozzle",
            "sub_path": "machine/Anycubic i3 Mega S 0.4 nozzle.json"
        },
        {
            "name": "Anycubic Chiron 0.4 nozzle",
            "sub_path": "machine/Anycubic Chiron 0.4 nozzle.json"
        },
        {
            "name": "Anycubic Vyper 0.4 nozzle",
            "sub_path": "machine/Anycubic Vyper 0.4 nozzle.json"
        },
        {
            "name": "Anycubic Kobra Max 0.4 nozzle",
            "sub_path": "machine/Anycubic Kobra Max 0.4 nozzle.json"
        },
        {
            "name": "Anycubic Kobra Plus 0.4 nozzle",
            "sub_path": "machine/Anycubic Kobra Plus 0.4 nozzle.json"
        },
        {
            "name": "Anycubic 4Max Pro 0.4 nozzle",
            "sub_path": "machine/Anycubic 4Max Pro 0.4 nozzle.json"
        },
        {
            "name": "Anycubic 4Max Pro 2 0.4 nozzle",
            "sub_path": "machine/Anycubic 4Max Pro 2 0.4 nozzle.json"
        },
        {
            "name": "Anycubic Kobra 2 0.4 nozzle",
            "sub_path": "machine/Anycubic Kobra 2 0.4 nozzle.json"
        }
    ]
}
